<template>
    <el-card>
        <el-row class="methodMonitor__title">方法监控配置</el-row>
        <!-- 搜索 -->
        <el-row class="methodMonitor__search">
            <div class="item">
                <span>监控Key:</span>
                <el-input style="width: 150px;" v-model.number="search.monitorKey" clearable
                    placeholder="请输入监控Key"></el-input>
            </div>
            <div class="item">
                <span>事件Code:</span>
                <el-input style="width: 150px;" v-model.number="search.eventCode" clearable
                    placeholder="请输入事件Code"></el-input>
            </div>
            <div class="item">
                <span>监控名称:</span>
                <el-input style="width: 150px;" v-model.number="search.name" clearable placeholder="请输入监控名称"></el-input>
            </div>
            <div class="item">
                <span>状态:</span>
                <el-select v-model="search.valid" clearable filterable placeholder="请选择" style="width: 100px;">
                    <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <el-button style="margin-left: 10px;" type="primary" @click="getMethodMonitor(1)">search</el-button>
            <el-button style="margin-left: 10px;" type="primary" @click="() => {
                dialogVisible = true
                type = 0
            }">新增</el-button>
        </el-row>
        <!-- 表格 -->
        <el-row>
            <el-table border :data="tableData">
                <el-table-column prop="monitorKey" label="监控Key" align="center">
                </el-table-column>
                <el-table-column prop="eventCode" label="活动码" align="center">
                </el-table-column>
                <el-table-column prop="name" label="监控名称" align="center">
                </el-table-column>
                <el-table-column prop="warnName" label="告警名称" align="center">
                </el-table-column>
                <el-table-column prop="valid" label="状态" align="center" width="150">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.valid"
                            @change="handleToggleValid(scope.row.monitorKey, scope.row.valid)" active-text="启用"
                            inactive-text="禁用" :active-value="1" :inactive-value="0">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="ctime" label="创建时间" align="center" :formatter="formatDate"></el-table-column>
                <el-table-column prop="mtime" label="修改时间" align="center" :formatter="formatDate"></el-table-column>
                <el-table-column prop="action" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" @click="copy(scope.row)">复制</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <!-- 分页 -->
        <el-row>
            <el-pagination background @current-change="getMethodMonitor" :current-page="search.pageNum"
                :page-size="search.pageSize" :total="total"></el-pagination>
        </el-row>
        <!-- 复制 -->
        <el-dialog title="复制" :visible.sync="copyDialogVisible" width="30%" @close="closeDialog('copy')">
            <el-form :model="copyInfo" label-width="120px">
                <el-form-item label="新监控Key">
                    <el-input v-model="copyInfo.newMonitorKey"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog('copy')">取消</el-button>
                <el-button type="primary" @click="handleCopy(copyInfo)">确定</el-button>
            </div>
        </el-dialog>
        <!-- 新增 / 编辑 -->
        <el-dialog :title="type == 0 ? '新增' : '编辑'" :visible.sync="dialogVisible" width="50%"
            @close="closeDialog(type)">
            <el-form :model="form" label-width="120px">
                <el-form-item label="监控Key">
                    <el-input v-model="form.monitorKey"></el-input>
                </el-form-item>
                <el-form-item label="事件Code">
                    <el-input v-model="form.eventCode"></el-input>
                </el-form-item>
                <el-form-item label="监控名称">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="告警名">
                    <el-input v-model="form.warnName"></el-input>
                </el-form-item>
                <el-form-item label="是否有效">
                    <el-switch v-model="form.valid" active-text="有效" inactive-text="无效" :active-value="1"
                        :inactive-value="0">
                    </el-switch>
                </el-form-item>
                <el-form-item label="监控列表">
                    <el-collapse v-model="activeNames" class="monitor-collapse">
                        <el-collapse-item v-for="(item, index) in form.monitorList" :key="index"
                            :title="'监控项 ' + (index + 1)" :name="index">
                            <el-row :gutter="20" class="monitor-item">
                                <el-col :span="22">

                                    <el-form-item label="监控周期类型">
                                        <el-select v-model="item.cycleType" placeholder="请选择监控周期类型" style="width: 100%">
                                            <el-option v-for="item in cycleTypeList" :key="item.value"
                                                :label="item.label" :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="监控等级">
                                        <el-select v-model="item.level" placeholder="请选择监控等级" style="width: 100%">
                                            <el-option v-for="item in levelList" :key="item.value" :label="item.label"
                                                :value="item.value"></el-option>
                                        </el-select>
                                    </el-form-item>

                                    <el-form-item label="最大失败率（万分率）">
                                        <el-input-number v-model="item.maxFailRate" :min="0" :max="10000"
                                            style="width: 100%"></el-input-number>
                                    </el-form-item>

                                    <el-form-item label="最大执行时长(s)">
                                        <el-input-number v-model="item.maxExecDuration" :min="0"
                                            style="width: 100%"></el-input-number>
                                    </el-form-item>

                                    <el-form-item label="监控描述">
                                        <el-input v-model="item.monitorDesc" type="textarea" :rows="2"></el-input>
                                    </el-form-item>

                                    <el-form-item label="监控周期(s)" v-if="item.cycleType == 3">
                                        <el-input-number v-model="item.monitorDuration" :min="0"
                                            style="width: 100%"></el-input-number>
                                    </el-form-item>

                                    <el-form-item label="监控开始时间" v-if="item.cycleType == 4">
                                        <el-date-picker v-model="item.monitorStartTime" type="datetime"
                                            value-format="timestamp" style="width: 100%"></el-date-picker>
                                    </el-form-item>

                                    <el-form-item label="监控结束时间" v-if="item.cycleType == 4">
                                        <el-date-picker v-model="item.monitorEndTime" type="datetime"
                                            value-format="timestamp" style="width: 100%"></el-date-picker>
                                    </el-form-item>

                                    <el-form-item label="检查排名空值" v-if="item.cycleType == 4">
                                        <el-switch v-model="item.needCheckRankEmpty"></el-switch>
                                    </el-form-item>

                                    <el-form-item label="最大排名空值率(万分率)" v-if="item.needCheckRankEmpty">
                                        <el-input-number v-model="item.maxRankEmptyRate" :min="0" :max="10000"
                                            style="width: 100%"></el-input-number>
                                    </el-form-item>

                                    <el-form-item label="最小执行次数" v-if="item.needCheckRankEmpty">
                                        <el-input-number v-model="item.minExecTimes" :min="0"
                                            style="width: 100%"></el-input-number>
                                    </el-form-item>

                                    <el-button type="danger" icon="el-icon-delete" circle
                                        @click="removeMonitorItem(index)"></el-button>
                                </el-col>
                            </el-row>
                        </el-collapse-item>
                    </el-collapse>
                    <el-button type="primary" icon="el-icon-plus" @click="addMonitorItem"
                        style="margin-top: 10px;">添加监控项</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog(type)">取消</el-button>
                <el-button type="primary" @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>

export default {
    name: 'MethodMonitor',
    data() {
        return {
            search: {
                monitorKey: null,
                eventCode: null,
                name: null,
                valid: null,
                pageNum: 1,
                pageSize: 20,
            },
            // 0: 新增, 1: 编辑
            type: 0,
            copyDialogVisible: false,
            copyInfo: {
                newMonitorKey: '',
                key: '',
            },
            tableData: [],
            total: 0,
            statusList: [
                { value: 1, label: '启用' },
                { value: 0, label: '禁用' },
            ],
            dialogVisible: false,
            levelList: [
                { value: 1, label: '重要' },
                { value: 2, label: '一般' },
            ],
            cycleTypeList: [
                { value: 1, label: '活动期间' },
                { value: 2, label: '每日监控' },
                { value: 3, label: '周期监控（小于一天）' },
                { value: 4, label: '定点周期监控' },
            ],
            form: {
                monitorKey: '',
                eventCode: '',
                name: '',
                warnName: '',
                valid: 0,
                monitorList: [{
                    cycleType: null,
                    level: null,
                    maxFailRate: 0,
                    maxExecDuration: 0,
                    monitorDesc: null,
                    monitorDuration: 0,
                    monitorStartTime: null,
                    monitorEndTime: null,
                    needCheckRankEmpty: false,
                    maxRankEmptyRate: 0,
                    minExecTimes: 0
                }]
            },
            activeNames: [0], // 默认展开第一个监控项
        }
    },
    mounted() {
        this.getMethodMonitor(1)
    },
    methods: {
        handleEdit(row) {
            this.type = 1
            this.form = JSON.parse(JSON.stringify(row))
            this.form.monitorList.forEach(item => {
                if (item.monitorStartTime) {
                    item.monitorStartTime = item.monitorStartTime * 1000
                }
                if (item.monitorEndTime) {
                    item.monitorEndTime = item.monitorEndTime * 1000
                }
            })
            this.dialogVisible = true
        },
        submit() {
            console.log(this.form);
            if (this.type == 0) {
                this.handleAdd(this.form, () => {
                    this.closeDialog(this.type)
                })
            } else {
                this.handleUpdate(this.form, () => {
                    this.closeDialog(this.type)
                })
            }
        },
        getMethodMonitor(page) {
            this.getMethodMonitor(page)
        },
        closeDialog(type) {
            if (type == 'copy') {
                this.copyDialogVisible = false
                this.copyInfo = {
                    newMonitorKey: '',
                    key: '',
                }
            } else {
                this.dialogVisible = false
                this.form = {
                    monitorKey: '',
                    eventCode: '',
                    name: '',
                    warnName: '',
                    valid: 0,
                    monitorList: [{
                        cycleType: null,
                        level: null,
                        maxFailRate: 0,
                        maxExecDuration: 0,
                        monitorDesc: null,
                        monitorDuration: 0,
                        monitorStartTime: null,
                        monitorEndTime: null,
                        needCheckRankEmpty: false,
                        maxRankEmptyRate: 0,
                        minExecTimes: 0
                    }]
                }
            }
        },
        copy(row) {
            this.copyInfo.key = row.monitorKey
            this.copyDialogVisible = true
        },
        //格式化时间
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property] * 1000
            if (data == null) {
                return null
            }
            let dt = new Date(data)
            return (
                dt.getFullYear() +
                '-' +
                (dt.getMonth() + 1) +
                '-' +
                dt.getDate() +
                ' ' +
                dt.getHours() +
                ':' +
                dt.getMinutes() +
                ':' +
                dt.getSeconds()
            )
        },
        async getMethodMonitor(page) {
            if (page) {
                this.search.pageNum = page;
            }
            const { data: res } = await this.$axios({
                method: 'GET',
                url: this.$store.getters.path.method_monitor_query,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    ...this.search
                },
            })
            if (res.code != 0) return this.$message(res.msg)
            this.tableData = res.data.data;
            this.total = res.data.total;
        },
        async handleAdd(info, fun) {
            const data = JSON.parse(JSON.stringify(info));

            data.monitorList.forEach(item => {
                if (item.monitorStartTime) {
                    item.monitorStartTime = item.monitorStartTime > 10000000000 ? item.monitorStartTime / 1000 : item.monitorStartTime;
                    if (item.monitorEndTime) {
                        item.monitorEndTime = item.monitorEndTime > 10000000000 ? item.monitorEndTime / 1000 : item.monitorEndTime;
                    }
                }
            })

            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.method_monitor_add,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    ...data,
                    operator: this.$store.getters.username
                },
            })
            if (res.code != 0) return this.$message(res.msg)
            this.$message.success('添加成功')
            fun && fun()
            this.getMethodMonitor()
        },
        async handleUpdate(info, fun) {
            const data = JSON.parse(JSON.stringify(info));
            data.monitorList.forEach(item => {
                if (item.monitorStartTime) {
                    item.monitorStartTime = item.monitorStartTime > 10000000000 ? item.monitorStartTime / 1000 : item.monitorStartTime;
                    if (item.monitorEndTime) {
                        item.monitorEndTime = item.monitorEndTime > 10000000000 ? item.monitorEndTime / 1000 : item.monitorEndTime;
                    }
                }
            })
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.method_monitor_update,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data,
            })
            if (res.code != 0) return this.$message(res.msg)
            this.$message.success('修改成功')
            fun && fun()
            this.getMethodMonitor()
        },
        async handleCopy(info) {
            const { data: res } = await this.$axios({
                method: 'GET',
                url: this.$store.getters.path.method_monitor_copy,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    ...info
                },
            })
            if (res.code != 0) return this.$message(res.msg)
            this.$message.success('复制成功')
            this.getMethodMonitor()
            this.closeDialog('copy')
        },
        async handleToggleValid(key, valids) {
            console.log("valids", valids);
            const { data: res } = await this.$axios({
                method: 'GET',
                url: this.$store.getters.path.method_monitor_toggle,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    key,
                    valid: valids,
                },
            })
            if (res.code != 0) return this.$message(res.msg)
            this.$message.success('修改成功')
            this.getMethodMonitor()
        },
        addMonitorItem() {
            this.form.monitorList.push({
                cycleType: null,
                level: null,
                maxFailRate: 0,
                maxExecDuration: 0,
                monitorDesc: null,
                monitorDuration: 0,
                monitorStartTime: null,
                monitorEndTime: null,
                needCheckRankEmpty: false,
                maxRankEmptyRate: 0,
                minExecTimes: 0
            });
        },
        removeMonitorItem(index) {
            this.form.monitorList.splice(index, 1);
        }
    }
}
</script>

<style scoped lang="scss">
.methodMonitor {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;

        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}

.monitor-collapse {
    :deep(.el-collapse-item__header) {
        font-size: 16px;
        font-weight: bold;
        background-color: #f5f7fa;
        padding: 0 15px;
    }

    :deep(.el-collapse-item__content) {
        padding: 20px;
    }
}

.monitor-item {
    .el-form-item {
        margin-bottom: 18px;
    }

    .delete-btn-col {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 5px;
    }
}

:deep(.el-input-number) {
    width: 100%;

    .el-input__inner {
        text-align: left;
    }
}
</style>